var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 35.585a2 2 0 0 0 2.828 0L39.414 23a2 2 0 0 0 0-2.829L26.828 7.585A2 2 0 0 0 24 10.413l9.172 9.172H6a2 2 0 1 0 0 4h27.172L24 32.757a2 2 0 0 0 0 2.828z"}));
}

ArrowRight.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
